import React from 'react';
import { 
  FloppyDisk, Eye, EyeSlash, Sparkle, Check, X, 
  Calendar, ArrowLeft, FileArrowUp 
} from '@phosphor-icons/react';
import AIToolbar from './AIToolbar';

export default function EditorToolbar({
  onSave,
  onPublish,
  onPreview,
  showPreview,
  onBack,
  saving = false,
  publishing = false,
  isDraft = true,
  contentType,
  title,
  content,
  metadata,
  onAITitleSuggestions,
  onAIContentImprovement,
  onAISummaryGeneration,
  onAITagsSuggestion,
  onAISEOGeneration
}) {
  return (
    <div className="sticky top-0 z-40 bg-background/95 backdrop-blur border-b border-border">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          {/* Left - Back Button & Title */}
          <div className="flex items-center gap-4 flex-1 min-w-0">
            <button
              onClick={onBack}
              className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-muted transition-colors"
            >
              <ArrowLeft size={20} />
              <span className="hidden sm:inline">Back</span>
            </button>
            
            <div className="border-l border-border h-8"></div>
            
            <div className="min-w-0 flex-1">
              <div className="text-xs text-muted-foreground capitalize">{contentType}</div>
              <div className="text-sm font-medium truncate">{title || 'Untitled'}</div>
            </div>
          </div>

          {/* Right - Actions */}
          <div className="flex items-center gap-2">
            {/* AI Assist */}
            <AIToolbar
              contentType={contentType}
              title={title}
              content={content}
              metadata={metadata}
              onTitleSuggestions={onAITitleSuggestions}
              onContentImprovement={onAIContentImprovement}
              onSummaryGeneration={onAISummaryGeneration}
              onTagsSuggestion={onAITagsSuggestion}
              onSEOGeneration={onAISEOGeneration}
            />

            {/* Preview Toggle */}
            <button
              onClick={onPreview}
              className={`hidden md:flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
                showPreview ? 'bg-primary text-primary-foreground' : 'hover:bg-muted'
              }`}
              title="Toggle Preview"
            >
              {showPreview ? <EyeSlash size={18} /> : <Eye size={18} />}
              <span className="hidden lg:inline">{showPreview ? 'Hide' : 'Preview'}</span>
            </button>

            {/* Save Draft */}
            <button
              onClick={onSave}
              disabled={saving}
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-muted hover:bg-muted/80 transition-colors disabled:opacity-50"
            >
              <FloppyDisk size={18} weight={saving ? 'fill' : 'regular'} />
              <span className="hidden sm:inline">{saving ? 'Saving...' : 'Save Draft'}</span>
            </button>

            {/* Publish */}
            <button
              onClick={onPublish}
              disabled={publishing}
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary text-primary-foreground hover:opacity-90 transition-opacity disabled:opacity-50"
            >
              {publishing ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                  <span className="hidden sm:inline">Publishing...</span>
                </>
              ) : (
                <>
                  <FileArrowUp size={18} weight="bold" />
                  <span className="hidden sm:inline">Publish</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
